<template>
  <div>
    <div class="d-start-start mb-3 mt-4">
      <left-text leftText="营业执照"/>
      <upload-image  :existImgs="priceArrs.certpic" :maxLength="1"/>
    </div>
    <div class="images-box">
      <div class="d-start-start mb-3 mt-4">
        <left-text leftText="消防验收合格证"/>
        <span v-if="!priceArrs.certfire">未上传</span>
        <upload-image  :existImgs="priceArrs.certfire" :maxLength="1"/>
      </div>
      <div class="d-start-start mb-3 mt-4">
        <left-text leftText="卫生许可证"/>
        <span v-if="!priceArrs.certheal">未上传</span>
        <upload-image  :existImgs="priceArrs.certheal" :maxLength="1"/>
      </div>
      <div class="d-start-start mb-3 mt-4">
        <left-text leftText="特种行业许可证"/>
        <span v-if="!priceArrs.certspec">未上传</span>
        <upload-image  :existImgs="priceArrs.certspec" :maxLength="1"/>
      </div>
    </div>
    <div class="d-flex mb-3"><left-text leftText="名称"/>{{priceArrs.title||'暂无'}}</div>
    <div class="d-flex mb-3"><left-text leftText="地址"/>{{pcd()}}</div> 
    <div class="d-flex mb-3"><left-text leftText="详细地址"/>{{priceArrs.address||'暂无'}}</div> 
    <div class="d-flex mb-3"><left-text leftText="修改原因"/>{{priceArrs.reason||'暂无'}}</div>     
  </div>
</template>

<script>
export default {
  props:['priceArrs'],
  methods: {
    pcd(){
      return  this.priceArrs.province_name + '' + this.priceArrs.city_name + '' + this.priceArrs.district_name||'暂无'
    },
  },
}
</script>

<style scoped>
.images-box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>